import { routeTo } from "@/app/routes";
import type { components } from "@/core/api/schema";

export type Notification = components["schemas"]["Notification"];

const text = (data: Notification["data"], key: string) =>
  typeof data?.[key] === "string" ? (data[key] as string) : undefined;

/** Where a message leads in the portal, if anywhere (types sent to brand teams: payouts.constant.ts). */
export function notificationLink(n: Notification): string | undefined {
  const brandId = text(n.data, "brandId");
  if (!brandId) return undefined;
  switch (n.type) {
    case "PAYOUT_ACCOUNT_CHANGED":
      return routeTo.money(brandId, "account");
    case "PAYOUT_PAID": {
      const payoutId = text(n.data, "payoutId");
      return payoutId ? routeTo.payout(brandId, payoutId) : routeTo.money(brandId, "payouts");
    }
    default:
      return undefined;
  }
}

/** "9+" past nine, so the badge stays small. */
export const badgeCount = (n: number) => (n > 9 ? "9+" : String(n));
